module.exports = __webpack_public_path__ + "img/nodata_utalk.bcf199af.png";